<template>
  <div class="pricing-template-container">
    <el-card class="box-card" v-loading.fullscreen.lock="loading">
      <sticky :z-index="10" class-name="submit-area">
        <el-button
          style="margin-left: 10px"
          type="success"
          @click="addPricing()"
        >
          Add
        </el-button>
        <el-button
          style="margin-left: 10px"
          :loading="submiting"
          type="primary"
          @click="submitCost()"
        >
          Submit
        </el-button>
      </sticky>
      <el-checkbox v-model="selectAll" @change="activeAll"
        >Select All</el-checkbox
      >
      <div
        class="cost-list"
        v-for="(pricing, index) in pricingLists"
        :key="index"
      >
        <el-table border stripe :data="pricing.pricings" style="width: 100%">
          <el-table-column
            prop="active"
            label="Active"
            width="60"
            header-align="center"
            align="center"
            fixed
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="pricingLists[index].pricings[scope.$index].active"
                @change="activeCost"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="320" fixed>
            <template slot="header">
              {{ pricing.header_text }}
            </template>
            <template slot-scope="scope">
              {{ scope.row.text }}
            </template>
          </el-table-column>

        <el-table-column label="Fee Collect from customer" header-align="center">
          <el-table-column
            prop="cost"
            label="Cost"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].cost"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="currency"
            label="Currency"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].currency"
                placeholder="Select"
              >
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="EUR" value="EUR"></el-option>
                <el-option label="USD" value="USD"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="is_percent"
            label="Is %"
            width="70"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="pricingLists[index].pricings[scope.$index].is_percent"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="percent"
            label="Percent"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
              type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].percent"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Fee collect from agent (under whitelable)" header-align="center">
          <el-table-column
            prop="system_fee"
            label="Fee"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="system_fee_currency"
            label="Fee Currency"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee_currency"
                placeholder="Select"
              >
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="EUR" value="EUR"></el-option>
                <el-option label="USD" value="USD"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="fee_ispercent"
            label="Fee Is %"
            width="80"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="pricingLists[index].pricings[scope.$index].system_fee_ispercent"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="system_fee_percent"
            label="Fee %"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-input
              type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee_percent"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Transaction name on statement" header-align="center">
          <el-table-column
            prop="fee_text"
            label="Fee Text"
            header-align="center"
            align="center"
            width="220"
          >
            <template slot-scope="scope">
              <el-input
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].fee_text"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>
          <el-table-column
            prop="railsbank_code"
            label="Code"
            header-align="center"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <el-input
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].railsbank_code"
              ></el-input>
            </template>
          </el-table-column>

        </el-table>
        <el-divider content-position="left"></el-divider>
      </div>
    </el-card>
    <PricingForm ref="PricingForm" v-on:created="getPricingTemplateData"/>
  </div>
</template>

<script>
import Sticky from "@/components/Sticky";
import { getPricingTemplate, updatePricingTemplate } from "@/api/pricing";
import { findObjectArray } from "@/utils";
import PricingForm from './components/pricing-form'
export default {
  components: { Sticky, PricingForm },
  props: {
    projectUID: String,
  },

  data() {
    return {
      loading: false,
      pricingLists: [],
      submiting: false,
      dialogFormVisible: false,
      loadingProject: false,
      submitingClone: false,
      selectAll: false,
    };
  },
  methods: {
    getPricingTemplateData() {
      this.loading = true;
      getPricingTemplate(this.projectUID).then(({ result, data }) => {
        this.loading = false;
        if (result && data) {
          this.pricingLists = data;
          this.activeCost()
        }
      });
    },
    mapData() {
      const formData = {
        pricings: [],
      };

      this.pricingLists.forEach((group) => {
        group.pricings.forEach((item) => {
          formData.pricings.push({
            pricing_group: item.pricing_group,
            pricing_code: item.pricing_code,
            text: item.text,
            cost: item.cost,
            currency: item.currency,
            is_percent: item.is_percent,
            percent: item.percent,
            active: item.active,
            fee_text: item.fee_text,
            system_fee: item.system_fee,
            system_fee_currency: item.system_fee_currency,
            system_fee_ispercent: item.system_fee_ispercent,
            system_fee_percent: item.system_fee_percent,
            railsbank_code: item.railsbank_code
          });
        });
      });

      return formData;
    },
    submitCost() {
      const formData = this.mapData();
      this.submiting = true;
      updatePricingTemplate(formData).then(({ result }) => {
        this.submiting = false;
        if (result) {
          this.$notify({
            title: "Success",
            message: `Update Pricing successfully`,
            type: "success",
            duration: 2000
          });
        }
      });
    },
    activeCost() {
      var activeAll = 0;
      var actived = 0;

      this.pricingLists.forEach((group) => {
        activeAll += group.pricings.length;
        actived += findObjectArray(group.pricings, true, "active").length;
      });

      this.selectAll = activeAll === actived ? true : false;
    },
    activeAll(value) {
      this.pricingLists.forEach((group) => {
        group.pricings.forEach((item) => {
          item.active = value;
        });
      });
    },
    addPricing(){
      this.$refs.PricingForm.showDialog()
    }
  },
  created() {
    this.getPricingTemplateData();
  },
};
</script>

<style lang="scss">
.pricing-template-container {
  .cost-list {
    display: block;
  }

  .el-card__body {
    padding-top: 5px;
    min-height: 200px;
  }

  .submit-area {
    background-color: white;
    height: 55px;
    line-height: 55px;
    position: relative;
    width: 100%;
    text-align: right;
  }

  .el-input__inner[type="number"]{
    padding: 0 5px;
    text-align: center;
  }

 

  table td:nth-child(7),
  table td:nth-child(8),
  table td:nth-child(9),
  table td:nth-child(10),
  table td:nth-child(11),
  table td:nth-child(12){
    background: #eaf5ff !important;
  }

}
</style>